import { ReactNode } from "react";

import { Text } from "../text/text";
import { emptyLabelClass, labelClass } from "./input-title.css";

interface InputTitleProps {
  /**
   * The id of the input the label is for
   */
  htmlFor: string;
  /**
   * Information to display in the info icon
   */
  info?: string;
  /**
   * Label text to display
   */
  title: string;
  /**
   * Secondary label text to display
   */
  secondaryTitle?: string;
  /**
   * Flag for displaying label space when title is not there
   */
  isEmptyLabel?: boolean;
  /**
   * Custom Styles
   */
  justifyContent?: "space-between" | "flex-start";
  /**
   * endItem is a ReactNode that can be used to add an element at the end of the title
   */
  endItem?: ReactNode;
}

/**
 * General Input Title
 */
export const InputTitle = ({
  title,
  htmlFor,
  info,
  isEmptyLabel,
  secondaryTitle,
  justifyContent = "space-between",
  endItem,
}: InputTitleProps) => {
  const getCustomStyle = () => {
    return {
      justifyContent,
      gap: 5,
    };
  };

  return (
    <div
      className={`${labelClass} ${isEmptyLabel ? emptyLabelClass : ""}`}
      style={getCustomStyle()}
      data-testid={`input-title-${htmlFor}`}
    >
      {!isEmptyLabel ? (
        <>
          <Text
            tagElement="label"
            htmlFor={htmlFor}
            styleVariant="heading4"
            colorVariant="primaryText"
          >
            {title}
          </Text>
          {secondaryTitle && (
            <Text
              tagElement="label"
              htmlFor={htmlFor}
              styleVariant="heading4"
              colorVariant="secondaryText"
            >
              {secondaryTitle}
            </Text>
          )}
        </>
      ) : (
        <Text styleVariant="heading4" tagElement="span">
          &nbsp;
        </Text>
      )}
      {info && (
        <Text
          tagElement="span"
          styleVariant="caption"
          colorVariant="secondaryText"
        >
          {info}
        </Text>
      )}
      {endItem}
    </div>
  );
};
